import { useTranslation } from 'react-i18next';

import { Confirmation } from 'core/components';
import { IJobVendor } from 'jobs/types';
import { Color } from 'theme/enums';

interface IProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  vendors: IJobVendor[];
}

export const RemoveVendorsConfirmation = ({ isOpen, onConfirm, onCancel, vendors }: IProps) => {
  const { t } = useTranslation();

  const getConfirmationMessage = () => {
    return t('messageConfirmRemoveVendors', {
      count: vendors.length,
      vendorName:
        vendors.length === 1
          ? vendors[0].foreignContactGroupName || t('labelTheVendor')
          : undefined,
    });
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Confirmation
      isOpen={true}
      title={t('titleRemoveVendor', { count: vendors.length })}
      message={getConfirmationMessage()}
      confirmBtnLabel={t('buttonLabelRemove')}
      confirmBtnColor={Color.DANGER}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
